<template>
  <div>
    <table class="table table-xs table-hover">

      <thead>

      <tr>
        <th colspan="5" class=" text-danger">ANLAŞMALI FİRMALAR
          <el-tooltip class="item" effect="dark"
                      content="Gider işlenirken Kategori seçildiğinde anlaşmalı firma listesi ve açıklaması bilgisi verilir"
                      placement="top">
            <i class="el-icon-info text-primary cursor-pointer"></i>
          </el-tooltip>

          <button v-if="Yetki"
                  @click="this.Ekle"
                  class="el-button TableBtn el-button--success el-button--mini float-right">FİRMA EKLE
          </button>
        </th>
      </tr>
      <tr>
        <th>Firma</th>
        <th>Kategori</th>
        <th>Açıklama</th>
        <th width="20" v-if="Yetki"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="FirmaDetay in Liste">
        <td>{{FirmaDetay.CariText}}</td>
        <td>{{FirmaDetay.KategoriText}}</td>
        <td>{{FirmaDetay.Aciklama}}</td>
        <td v-if="Yetki">

          <el-tooltip class="item" effect="dark"
                      :content="Sayfa.SilAdi"
                      placement="top-start">
            <a href="#" @click="SilOnay(FirmaDetay.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
          </el-tooltip>


        </td>
      </tr>
      </tbody>

    </table>

    <el-form v-if="Form.Form" class="BilgiForm" :rules="FormHata" :model="Form"
             @submit.prevent.native="FirmaKaydet"
             ref="Firma">
      <h2>{{Form.Baslik}} <a @click="Form=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Kategori" prop="Kategori_id">
            <el-cascader
              size="mini"
              :props="{ multiple: true}"
              :options="KategoriSelect"
              v-model="Form.Kategori_id"
              collapse-tags
              filterable></el-cascader>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Firma" prop="Cari_id">
            <el-select v-model="Form.Cari_id" size="mini" filterable>
              <el-option
                v-for="item in CariSelect"
                :key="item.id"
                :label="item.Unvan"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Açıklama" prop="Aciklama">
            <el-input size="mini" type="textarea" v-model="Form.Aciklama">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <button type="button" @click="FirmaKaydet"
              class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">KAYDET
      </button>

    </el-form>
  </div>
</template>


<script>
  export default {
    props: {
      BinaBilgi: Object
    },
    data() {
      return {
        Sayfa: {
          ButtonAdi: this.$t('eGenel.10'),
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Button: null,
          Adi: this.$t('eYonetim.20.0'),
          Menu: [],
          MenuDisplay: null,
        },
        Yetki: false,
        Liste: [],
        KategoriSelect: [],
        CariSelect: [],
        Form: {
          Baslik: 'Anlaşmalı Firma Ekle',
          id: null,
          Form: false,
          Cari_id: null,
          Bina_id: this.BinaBilgi.id,
          Kategori_id: null,
          Aciklama: null
        },
        FormHata: {
          Cari_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }

      }
    },
    methods: {
      FirmaKaydet() {
        this.$refs['Firma'].validate((valid) => {
            if (valid) {

              // EKLE
              this.$store.dispatch("Post", {
                ...this.Form,
                path: 'yonetim/bina/anlasma/' + this.BinaBilgi.id
              })
                .then(response => {
                  if (response.Durum == "OK") {
                    this.SayfaYukle();
                    this.$message.success(response.Mesaj);
                    this.Form = {
                      Baslik: 'Firma Ekle',
                      id: null,
                      Form: false,
                      Cari_id: null,
                      Bina_id: this.BinaBilgi.id,
                      Kategori_id: null
                    }
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            }
          }
        );
      },
      SayfaYukle() {
        if (this.BinaBilgi.id) {
          this.$store.dispatch("Get", {path: 'yonetim/bina/anlasma/' + this.BinaBilgi.id})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Liste = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
          this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.KategoriSelect = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
          this.$store.dispatch("Get", {path: 'muhasebe/cari'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.CariSelect = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
        }

        this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
      },
      Ekle() {
        this.Form = {
          Baslik: 'Anlaşmalı Firma Ekle',
          id: null,
          Form: true,
          Cari_id: null,
          Kategori_id: null,
          Aciklama: null,
          Bina_id: this.BinaBilgi.id
        }
      },

      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/anlasma/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.ModalOlayi = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },

    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/Firma.vue